<template>
  <div class="flex flex-col items-center justify-center text-center gap-10 mb-12">
    <div
      v-if="icon"
      class="border border-grey-dark-300 rounded-[10px] custom-shadow w-12 h-12 flex items-center justify-center"
    >
      <component :is="icon" class="w-6 h-6 text-base-white" />
    </div>
    <h2 class="max-w-3xl text-4xl md:text-5xl font-semibold text-white">
      {{ title }}
    </h2>
    <p v-if="description" class="max-w-3xl text-lg md:text-xl font-light text-grey-dark-300">
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

interface Props {
  icon?: Component;
  title: string;
  description?: string;
}
defineProps<Props>();
</script>
